import { Button, Card, Divider, makeStyles, mergeClasses } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { ReactNode } from 'react';

export type TSelectElement = {
  content: string | ReactNode;
  icon?: ReactNode;
  onRemove?: () => void;
};

const SelectElement = ({ content, icon, onRemove }: TSelectElement) => {
  return (
    <div className="flex justify-between items-center px-3 py-1">
      <div className="flex items-center">
        {icon && <div className="mr-2">{icon}</div>}
        {content}
      </div>
      {onRemove && <Button appearance="transparent" size="small" icon={<DismissRegular />} onClick={onRemove} />}
    </div>
  );
};

type TProps = {
  elements: TSelectElement[];
  className?: string;
};

const useStyles = makeStyles({
  card: {
    padding: 0,
    gap: 0,
  },
});

const SelectList = ({ elements, className = '' }: TProps) => {
  const classes = useStyles();
  return (
    <Card className={mergeClasses(classes.card, className)}>
      {elements.map((element, index) => (
        <div key={index} className="w-full">
          {index > 0 && <Divider />}
          <SelectElement {...element} />
        </div>
      ))}
    </Card>
  );
};

export { SelectList };
